import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { NotificationsService } from 'app/layout/common/notifications/notifications.service';
import { ShortcutsService } from 'app/layout/common/shortcuts/shortcuts.service';
import { forkJoin, of, take, tap } from 'rxjs';
import { UserService } from './core/user/user.service';

export const initialDataResolver = (route, state) => {
    const navigationService = inject(NavigationService);
    const notificationsService = inject(NotificationsService);
    const shortcutsService = inject(ShortcutsService);
    const router: Router = inject(Router);
    const currentUser = inject(UserService);

    // Fork join multiple API endpoint calls to wait all of them to finish
    return forkJoin([
        navigationService.get(),
        notificationsService.getAll(),
        shortcutsService.getAll(),
        currentUser.getCurrentUser(),
    ]).pipe(
        take(1),
        tap((result) => {
            const hasNavigation: boolean = !!getAllChildLinks(
                result[0].horizontal,
            ).find((item) => {
                const splittedString = state.url.split('/');
                const extractedString = splittedString.slice(0, 4).join('/');
                const splitCount = splittedString.filter((part: string) =>
                    extractedString.includes(part),
                );

                return splitCount.length >= 2 && extractedString.includes(item);
            });

            console.log('has navigation', hasNavigation);
            if (!hasNavigation) {
                const urlPath = router.navigate(['/']);
                return of(urlPath);
            }
            return of(true);
        }),
    );
};

export const getAllChildLinks = (
    childItems: FuseNavigationItem[],
): string[] => {
    const links: string[] = [];

    for (const childItem of childItems) {
        if (childItem.link) {
            links.push(childItem.link);
        }

        if (childItem.children) {
            const childLinks = getAllChildLinks(childItem.children);
            links.push(...childLinks);
        }
    }

    return links;
};
